module.exports = __webpack_public_path__ + "img/Fond_decoration_de_table.8d9c5c9.jpg";